module.exports = __webpack_public_path__ + "officialStatic/img/xPartner2.75a1874.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/xPartner2.png
// module id = ph+1
// module chunks = 0